<script>
  import * as restfulService from '../../../../../services/restfulService'
  import * as MESSAGES from '../../../../../messages'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapActions} from 'vuex'

  import moment from 'moment'
  import {cloneDeep} from 'lodash'
  import {requiredIf} from 'vuelidate/lib/validators'

  export default {
    mixins: [helpers],
    props: ['dados'],
    data () {
      return {
        buscandoCidades: false,
        buscarCidadeEnderecoCobranca: null,
        botaoClicado: false,
        data: {
          pessoa: {
            id: ''
          },
          pessoa_fisica: {
            dt_nascimento: '',
            dt_nascimento_formatada: ''
          },
          endereco_cobranca: {
            id: null,
            nome: '',
            cpf_cnpj: '',
            cep: '',
            rua: '',
            numero: '',
            bairro: '',
            complemento: '',
            ref_cidade: ''
          }
        },
        dependencias: {
          cidades: []
        }
      }
    },
    validations: {
      data: {
        endereco_cobranca: {
          nome: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          },
          cpf_cnpj: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          },
          cep: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          },
          rua: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          },
          numero: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          },
          bairro: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          },
          ref_cidade: {
            required: requiredIf(function () {
              return this.menorDeIdade
            })
          }
        }
      }
    },
    computed: {
      menorDeIdade: function () {
        return moment().diff(moment(this.data.pessoa_fisica.dt_nascimento, 'YYYY-MM-DD'), 'years', false) < 18
      },
      enderecoCobrancaNomeErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.nome.$dirty) return erros
        !this.$v.data.endereco_cobranca.nome.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      enderecoCobrancaCpfErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.cpf_cnpj.$dirty) return erros
        !this.$v.data.endereco_cobranca.cpf_cnpj.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      enderecoCobrancaCepErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.cep.$dirty) return erros
        !this.$v.data.endereco_cobranca.cep.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      enderecoCobrancaRuaErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.rua.$dirty) return erros
        !this.$v.data.endereco_cobranca.rua.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      enderecoCobrancaNumeroErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.numero.$dirty) return erros
        !this.$v.data.endereco_cobranca.numero.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      enderecoCobrancaBairroErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.bairro.$dirty) return erros
        !this.$v.data.endereco_cobranca.bairro.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      enderecoCobrancaRefCidadeErros () {
        const erros = []
        if (!this.$v.data.endereco_cobranca.ref_cidade.$dirty) return erros
        !this.$v.data.endereco_cobranca.ref_cidade.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      }
    },
    mounted () {
      this.data.pessoa = {...this.data.pessoa, ...this.dados.pessoa}
      this.data.pessoa_fisica = {...this.data.pessoa_fisica, ...this.dados.pessoa_fisica}
      if (this.dados.endereco_cobranca.cidade) {
        this.dependencias.cidades.push(this.dados.endereco_cobranca.cidade)
      }
      this.data.endereco_cobranca = {...this.data.endereco_cobranca, ...this.dados.endereco_cobranca}
    },
    watch: {
      buscarCidadeEnderecoCobranca: function (query) {
        if (!this.data.endereco_cobranca.ref_cidade) {
          this.buscarCidades(query)
        }
      }
    },
    methods: {
      ...mapActions(['setUser', 'showNotification']),
      buscarCidades (query) {
        return new Promise((resolve, reject) => {
          if (query !== null && query !== '') {
            if (query !== null && query !== '') {
              this.dependencias.cidades.splice(0)
              this.buscandoCidades = true
              let data = {nome: {ilike: '%' + query + '%'}}
              restfulService.search('cidade', null, data, null, ['estado'])
                .then((response) => {
                  this.dependencias.cidades.splice(0)
                  this.dependencias.cidades = [...this.dependencias.cidades, ...response.data]
                  this.buscandoCidades = false
                  resolve()
                })
                .catch(e => {
                  console.log(e)
                  this.buscandoCidades = false
                  reject()
                })
            } else {
              resolve()
            }
          } else {
            resolve()
          }
        })
      },
      salvarDados () {
        this.botaoClicado = true
        bus.$emit('show-loader')
        let data = cloneDeep(this.data)
        delete data.necessidade
        delete data.pessoa.cidade
        delete data.pessoa.pessoa_fisica
        delete data.pessoa.usuario
        delete data.pessoa.necessidades_especiais
        delete data.pessoa_fisica.dt_nascimento_formatada
        delete data.pessoa.email_valido
        data.pessoa.cep = this.onlyNumbers(data.pessoa.cep)
        if (data.pessoa_fisica.fone_recado) {
          data.pessoa_fisica.fone_recado = this.onlyNumbers(data.pessoa_fisica.fone_recado)
        }
        if (data.pessoa_fisica.fone_profissional) {
          data.pessoa_fisica.fone_profissional = this.onlyNumbers(data.pessoa_fisica.fone_profissional)
        }
        if (data.pessoa_fisica.fone_celular) {
          data.pessoa_fisica.fone_celular = this.onlyNumbers(data.pessoa_fisica.fone_celular)
        }
        if (data.pessoa_fisica.fone_residencial) {
          data.pessoa_fisica.fone_residencial = this.onlyNumbers(data.pessoa_fisica.fone_residencial)
        }
        if (data.endereco_cobranca.cpf_cnpj) {
          data.endereco_cobranca.cpf_cnpj = this.onlyNumbers(data.endereco_cobranca.cpf_cnpj)
        }
        if (data.endereco_cobranca.cep) {
          data.endereco_cobranca.cep = this.onlyNumbers(data.endereco_cobranca.cep)
        }
        if (!data.endereco_cobranca.id) {
          delete data.endereco_cobranca.id
        }
        data.ref_pessoa = this.data.pessoa.id
        restfulService.post('pessoa', null, null, data)
          .then(() => {
            this.showNotification({
              message: 'Seus dados pessoais foram salvos'
            })
            this.$v.data.endereco_cobranca.$reset()
            this.botaoClicado = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.botaoClicado = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <v-form>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.nome"
                                  label="Nome do Responsável"
                                  :error-messages="enderecoCobrancaNomeErros"
                                  @input="$v.data.endereco_cobranca.nome.$touch()"
                                  @blur="$v.data.endereco_cobranca.nome.$touch()"
                                  required/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.cpf_cnpj"
                                  label="CPF do Responsável"
                                  v-mask="'###.###.###-##'"
                                  :error-messages="enderecoCobrancaCpfErros"
                                  @input="$v.data.endereco_cobranca.cpf_cnpj.$touch()"
                                  @blur="$v.data.endereco_cobranca.cpf_cnpj.$touch()"
                                  required/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.cep"
                                  label="CEP"
                                  v-mask="'#####-###'"
                                  :error-messages="enderecoCobrancaCepErros"
                                  @input="$v.data.endereco_cobranca.cep.$touch()"
                                  @blur="$v.data.endereco_cobranca.cep.$touch()"
                                  required/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-autocomplete v-model="data.endereco_cobranca.ref_cidade"
                                    :error-messages="enderecoCobrancaRefCidadeErros"
                                    @input="$v.data.endereco_cobranca.ref_cidade.$touch()"
                                    @blur="$v.data.endereco_cobranca.ref_cidade.$touch()"
                                    :items="dependencias.cidades"
                                    :loading="buscandoCidades"
                                    :search-input.sync="buscarCidadeEnderecoCobranca"
                                    item-text="nome"
                                    item-value="id"
                                    label="Cidade"
                                    placeholder="Digite o nome da cidade"
                                    no-data-text="Nenhuma registro encontrado"
                                    hide-no-data
                                    hide-selected
                                    clearable></v-autocomplete>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.rua"
                                  :error-messages="enderecoCobrancaRuaErros"
                                  @input="$v.data.endereco_cobranca.rua.$touch()"
                                  @blur="$v.data.endereco_cobranca.rua.$touch()"
                                  label="Rua"/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.numero"
                                  :error-messages="enderecoCobrancaNumeroErros"
                                  @input="$v.data.endereco_cobranca.numero.$touch()"
                                  @blur="$v.data.endereco_cobranca.numero.$touch()"
                                  label="Número"/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.bairro"
                                  :error-messages="enderecoCobrancaBairroErros"
                                  @input="$v.data.endereco_cobranca.bairro.$touch()"
                                  @blur="$v.data.endereco_cobranca.bairro.$touch()"
                                  label="Bairro"/>
                </v-flex>
                <v-flex sm6 xs12>
                    <v-text-field v-model="data.endereco_cobranca.complemento"
                                  label="Complemento"/>
                </v-flex>
            </v-layout>
            <v-btn color="success"
                   @click="salvarDados()"
                   :disabled="botaoClicado || $v.data.endereco_cobranca.$invalid">
                <i class="fas fa-check"></i>
                <span class="pl-2">Salvar Dados</span>
            </v-btn>
        </v-container>
    </v-form>
</template>



// WEBPACK FOOTER //
// EnderecoCobranca.vue?30035410